// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

export const SPORT_TYPES = [
    { name: 'Box cricket', value: 'box_cricket' },
    { name: 'Cricket net', value: 'cricket_net' },
    { name: 'Foot ball', value: 'football' }
];

export const PAYMENT_MODE = [
    { name: 'Full Payment', value: 'full' },
    { name: 'Advance', value: 'advance' },
    { name: 'Custom', value: 'custom' }
];

export const GENDER = [
    { name: 'Male', value: 'male' },
    { name: 'Female', value: 'female' },
    { name: 'Others', value: 'others' }
];

export const SLOT_DURATION = [
    { name: '30 mins', value: '30' },
    { name: '60 mins', value: '60' }
];

export const USER_TYPE = [
    { name: 'Venue Manager', value: 'venue_manager' },
    { name: 'Customer', value: 'customer' }
];

export const SNACKBAR = {
    maxSnack: 10,
    autoHideDuration: 3000,
    anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
    success: { variant: 'success' },
    error: { variant: 'error' },
    warning: { variant: 'warning' },
    info: { variant: 'info' }
};

export const TRANSACTION_STATUS = [
    { name: 'Payment Initiated', value: 'started' },
    { name: 'Pending', value: 'pending' },
    { name: 'Cancelled', value: 'cancelled' },
    { name: 'Failed', value: 'failed' },
    { name: 'Paid', value: 'paid' },
    { name: 'Refund Initiated', value: 'refund_initiated' },
    { name: 'Refund Processed', value: 'refund_processed' },
    { name: 'Refund Failed', value: 'refund_failed' }
];

export const TRANSACTION_TRANSFER_STATUS = [
    { name: 'Yet to Start', value: 'yet_to_start' },
    { name: 'Transfer Initiated', value: 'started' },
    { name: 'Cancelled', value: 'cancelled' },
    { name: 'Pending', value: 'pending' },
    { name: 'Transferred', value: 'completed' },
    { name: 'Reversed', value: 'reversed' }
];

export const BOOKING_TYPES = [
    { name: 'Court', value: 'venue' },
    { name: 'Board', value: 'board' }
];

export const BOOKING_STATUS = [
    { name: 'Reserved', value: 'reserved' },
    { name: 'Booked', value: 'confirmed' },
    { name: 'Cancelled', value: 'cancelled' },
    { name: 'Blocked', value: 'blocked' }
];

export const PAYMENT_STATUS = [
    { name: 'Initiated', value: 'reserved' },
    { name: 'Paid', value: 'confirmed' },
    { name: 'Cancelled', value: 'cancelled' },
    { name: 'Refunded', value: 'refunded' },
    { name: 'Failed', value: 'failed' },
    { name: 'Refund Initiated', value: 'refund_initiated' },
    { name: 'Refund Failed', value: 'refund_failed' },
];

export const USER_STATUS = [
    { name: 'Active', value: 1 },
    { name: 'Inactive', value: 0 }
];

export const PAYMENT_TYPE = [
    { name: 'Online', value: 'online' },
    { name: 'Offline', value: 'offline' }
];

export const IMAGE_FORMAT = [
    'png', 'jpeg', 'jpg'
];

export const DELETED_STATUS = [

    { name: 'Active', value: 0 },
    { name: 'Inactive', value: 1 }
];
